import React, { Component } from 'react'
import { connect } from 'react-redux';
import './prevents.scss';
import $$CACHE from '../../../helpers/cache';
import { LOTTERY_MENUS } from '../../../constants/menus/lotteryMenus';
export class Prevents extends Component {
  constructor(){
    super();
    this.state = {};
  }
  componentDidMount(){
    this.props.$$LOTTERY.getPreventLotterys((res) => {
      this.setState({prevents: res.data});
    })
    this.timer = window.setInterval(this.checkPrevents, 500)
  }
  checkPrevents = () => {
    if(!this.state.prevents){return;}
    const rule = _.find(this.state.prevents, {lotteryId: this.props.lotteryId});
    if(!rule){return;}
    const trigger = {
      triggerTime: _.now(),
      lotteryId: this.props.lotteryId
    }
    let showIt = false;
    let canClose = true;
    if(rule.type == 2){
      canClose = false;
    }
    let preventTimer = _.get($$CACHE.get('prevent-timers'), 'data');
    const storeTimer = _.find(preventTimer, {lotteryId: this.props.lotteryId});
    if(!preventTimer || (preventTimer && !storeTimer)){
      preventTimer = preventTimer || [];
      preventTimer.push(trigger);
      showIt = true;
    }
    else if(((_.now() - storeTimer.triggerTime) / 1000) > Number(rule.interval * 60)){
      preventTimer = _.filter(preventTimer, item => item.lotteryId != this.props.lotteryId);
      preventTimer.push(trigger);
      showIt = true;
    }
    if(showIt){
      if(canClose){
        $$CACHE.put('prevent-timers', preventTimer, 7);
      }
      this.setState({
        display: {
          recommends: _.chain($.makeLott(LOTTERY_MENUS))
                       .map('lotterys')
                       .flatten()
                       .filter(item => _.includes(rule.recommends, _.toString(item.lotteryId)))
                       .map(item => ({index: _.findIndex(rule.recommends, it => it == item.lotteryId), ..._.pick(item, ['uri', 'flaglot'])}))
                       .orderBy(['index'])
                       .value(),
          text: rule.memo,
          canClose
        }
      })
    }
  }

  componentDidUpdate(){
    if(this.state.display){
      document.querySelector('body').style.overflow = 'hidden';
      document.querySelector('html').style.overflowY = 'hidden';
    }else{
      document.querySelector('body').style.overflow = 'auto';
      document.querySelector('html').style.overflowY = 'auto';
    }
  }
  
  componentWillUnmount(){
    document.querySelector('body').style.overflow = 'auto';
    document.querySelector('html').style.overflowY = 'auto';
    window.clearInterval(this.timer);
  }
  goBet = (uri) => {
    this.setState({
      display: null
    })
    window.location.hash = uri;
  }
  render() {
    return (
      <div>
        {
          this.state.display && 
          <div className='prevent-lottery-box'>
            <div className="content">
              <div className="text">{this.state.display.text}</div>
              <div className="lottery-boxs">
                {
                  this.state.display.recommends.map((item, index) => 
                    <div onClick={() => this.goBet(item.uri)} key={index} className={`item n${this.state.display.recommends.length}`}>
                      <i style={{backgroundImage: 'url(' + require('../../../i/pc-day/lottery/icons/' + item.flaglot + '.png') + ')'}} />
                      <span>立即投注</span>
                    </div>
                  )
                }
              </div>
            </div>
            {
              (this.state.display.canClose || _.includes(['UAT', 'DEBUG'], window.MODEL)) && 
              <div className="close" onClick={() => this.setState({display: null})}></div>
            }
          </div>
        }
      </div>
    )
  }
}
function mapStateToProps() {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
    $$LOTTERY: bindActionCreators(lotteryAction, dispatch)
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Prevents);